<template>
  <div class="step1" v-if="content.type==9&&content.show">
    <p>素质项：{{content.title}}</p>
    <RateScale v-for="(pep,zindex) in content.options" :content="pep" v-on:listenToChildEvent="selectAnswer"></RateScale>
  </div>
</template>
<script>
import RateScale from '../components/RateScale'
export default {
  props:{
    content:Object
  },
  components: {
    'RateScale':RateScale
  },
  data(){
    return{
    }
  },
  methods:{
    selectAnswer(item,index,type){
      this.$emit("listenToChildEvent",item,index)
    }
  }
}
</script>
<style lang="stylus" scoped>
  .element-box1
    background-color:#C2E8F1
    margin:0.1rem
    padding:0.1rem
  .element-box2
    background-color:#CDCDCD
    margin:0.2rem 0.1rem
    padding:0.1rem
  .element-box3
    background-color:#C1E7F0
    margin:0.1rem
    padding:0.1rem
  .direction-box
    overflow:hidden
    li
      float:left
      background-color:#FFFFFF
      margin:0.1rem
      padding:1px
      border-radius:6px
      display: flex;
      display:-webkit-flex;
      justify-content: center;/*水平居中*/
      align-items: center;/*垂直居中*/
      -webkit-align-items:center;
      height:0.8rem
      line-height:0.3rem
    .selected
      background-color:#DC6E5A
      color:#ffffff
    .col2
      width:46%
    .col3
      width:29%
    .col4
      width: 21%
      text-align: center
  .protrude
    color:#DC6E5A
    font-weight:bold
  .modal-box
    .modal-content
      background-color:#F5F5F5
      .modal-body
        background-color:#FFFFFF
        border:1px solid #BBBBBB
        margin:0.3rem
        padding:0.1rem
        .modal-title
          color:#434343
        .modal-text
          text-align:left
          color:#777777
      .tips
        color:#101010
      .btn-group
        overflow:hidden;
        width:90%
        margin:auto
        .default-btn
          display:inline-block
          width:44%
        .primary-btn
          float:left
          background-color:#008DCF
        .disabled-btn
          float:right
          background-color:#B5B5B5
</style>
